<script setup>
// "?" with a popover on hover, tap or keyboard focus; the content goes into the default slot.
// The popover is display:none while closed, so it never widens the page (docs/design/SPEC.md, item 1).
defineProps({
  label: {
    type: String,
    default: '?',
  },
  // 'right' for hints near the right edge of the screen: the popover opens to the left.
  align: {
    type: String,
    default: 'left',
  },
});
</script>

<template>
  <span class="group relative inline-flex">
    <button
      type="button"
      class="flex size-4 items-center justify-center rounded-full border border-slate-600 text-[0.625rem] leading-none text-slate-400 hover:border-slate-400 hover:text-slate-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500"
      :aria-label="label"
    >?</button>
    <span
      role="tooltip"
      class="pointer-events-none absolute top-full z-30 mt-2 hidden w-[min(18rem,calc(100vw-2rem))] rounded-lg border border-slate-700 bg-slate-900 p-3 text-xs font-normal leading-relaxed text-slate-300 shadow-xl group-hover:block group-focus-within:block"
      :class="align === 'right' ? 'right-0' : 'left-0'"
    >
      <slot />
    </span>
  </span>
</template>
